/**
 * Custom markdown transformers for Lexical.
 *
 * These transformers handle conversion of custom tag syntax to/from markdown.
 */

import { TextMatchTransformer, TRANSFORMERS } from "@lexical/markdown";
import {
  DimensionTagNode,
  $createDimensionTagNode,
  $isDimensionTagNode,
} from "../nodes/DimensionTagNode";

// ============================================
// Dimension Tag Transformer
// Matches: [DIMENSION:123] or [DIMENSION:123:Label Text]
// ============================================

export const DIMENSION_TAG_TRANSFORMER: TextMatchTransformer = {
  dependencies: [DimensionTagNode],
  export: (node) => {
    if (!$isDimensionTagNode(node)) return null;
    const dimId = node.getDimId();
    const label = node.getLabel();
    return label ? `[DIMENSION:${dimId}:${label}]` : `[DIMENSION:${dimId}]`;
  },
  importRegExp: /\[DIMENSION:(\d+)(?::([^\]]+))?\]/,
  regExp: /\[DIMENSION:(\d+)(?::([^\]]+))?\]$/,
  replace: (textNode, match) => {
    const dimId = parseInt(match[1], 10);
    const label = match[2] || "";
    const node = $createDimensionTagNode({ dimId, label });
    textNode.replace(node);
  },
  trigger: "]",
  type: "text-match",
};

// ============================================
// Combined Transformers
// ============================================

/**
 * All custom transformers combined with standard markdown transformers.
 * Use this for markdown import/export operations.
 */
export const CUSTOM_TRANSFORMERS = [
  DIMENSION_TAG_TRANSFORMER,
  // TODO: Add PERSON_MENTION_TRANSFORMER and FILE_MENTION_TRANSFORMER
  ...TRANSFORMERS, // Standard markdown transformers (bold, italic, headings, lists, etc.)
];
